import "./App.css";
import "react-toastify/dist/ReactToastify.css";

import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import MainRoute from "./routes/main";
import NotesPage from "./routes/notes";
import NoteDetailRoute from "./routes/note-details";
import { routes } from "./routes";
import MagazinesPage from "./routes/magazines";
import MagazineDetailsPage from "./routes/magazine-details";
import UserPage from "./routes/users";
import UserDetailsScreen from "./routes/user-details";
import ProfilesPage from "./routes/profiles";
import ProfileDetailsScreen from "./routes/profile-details";
import AdsPage from "./routes/ads";
import AdsDetailsScreen from "./routes/ads-details";
import SettingsScreen from "./routes/settings";
import HeadersPage from "./routes/headers";
import LoginScreen from "./routes/login";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/authContext";
import HeaderDetailScreen from "./routes/header-details";
import AdsSectionsScreen from "./routes/ads-sections";
import AdsSectionsDetailsScreen from "./routes/ads-sections-details";
import PagesPage from "./routes/pages";
import PageDetailsScreen from "./routes/page-details";
import AuthorsPage from "./routes/authors";
import AuthorDetailsScreen from "./routes/author-details";
import AdsCampaignPage from "./routes/ads-campaign";

const App = () => {
  return (
    <>
      <ToastContainer />
      <AuthProvider>
        <Routes>
          <Route path={routes.HOME} element={<LoginScreen />} />
          <Route path={routes.DASHBOARD} element={<MainRoute />}>
            <Route
              path={routes.NOTES}
              element={
                <ProtectedRoute>
                  <NotesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.NOTE_DETAILS}
              element={
                <ProtectedRoute>
                  <NoteDetailRoute />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.MAGAZINES}
              element={
                <ProtectedRoute>
                  <MagazinesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.MAGAZINE_DETAILS}
              element={
                <ProtectedRoute>
                  <MagazineDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.USERS}
              element={
                <ProtectedRoute>
                  <UserPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.USERS_DETAILS}
              element={
                <ProtectedRoute>
                  <UserDetailsScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.PROFILES}
              element={
                <ProtectedRoute>
                  <ProfilesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.PROFILE_DETAILS}
              element={
                <ProtectedRoute>
                  <ProfileDetailsScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.ADS}
              element={
                <ProtectedRoute>
                  <AdsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.ADS_DETAILS}
              element={
                <ProtectedRoute>
                  <AdsDetailsScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.ADS_CAMPAIGN}
              element={
                <ProtectedRoute>
                  <AdsCampaignPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.SETTINGS}
              element={
                <ProtectedRoute>
                  <SettingsScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.HEADERS}
              element={
                <ProtectedRoute>
                  <HeadersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.HEADER_DETAILS}
              element={
                <ProtectedRoute>
                  <HeaderDetailScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.ADS_SECTIONS}
              element={
                <ProtectedRoute>
                  <AdsSectionsScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.ADS_SECTIONS_DETAILS}
              element={
                <ProtectedRoute>
                  <AdsSectionsDetailsScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.PAGES}
              element={
                <ProtectedRoute>
                  <PagesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.PAGE_DETAILS}
              element={
                <ProtectedRoute>
                  <PageDetailsScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.AUTHORS}
              element={
                <ProtectedRoute>
                  <AuthorsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.AUTHOR_DETAILS}
              element={
                <ProtectedRoute>
                  <AuthorDetailsScreen />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </AuthProvider>
    </>
  );
};

export default App;
